import { useEffect, useState } from "react"

import { formatRelativeMinutes } from "@/lib/format"

interface Props {
  at: number
  refreshing: boolean
}

const STALE_MS = 20 * 60 * 1000 // 20 minutes

export function LastUpdatedBadge({ at, refreshing }: Props) {
  // Tick every 30s so the relative time stays accurate without re-fetching.
  const [, force] = useState(0)
  useEffect(() => {
    const id = setInterval(() => force((n) => n + 1), 30_000)
    return () => clearInterval(id)
  }, [])

  const ageMs = Date.now() - at
  const isStale = ageMs > STALE_MS

  return (
    <p
      className="mb-2 text-[11px] text-slate-500"
      title={new Date(at).toLocaleString("en-CA")}
    >
      Updated {formatRelativeMinutes(at)}
      {refreshing && <span className="ml-2 text-blue-500">· refreshing…</span>}
      {isStale && !refreshing && (
        <span className="ml-2 font-semibold text-orange-600">
          · data may be stale
        </span>
      )}
    </p>
  )
}
